// The two helpers every vote page repeats: initials for a project with no logo, and
// the check that a stored logo is still the repo scaffolder's placeholder.
export function getInitials(name: string): string {
  const parts = name.split(' ');
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return name.charAt(0).toUpperCase();
}

export function isDefaultLogo(
  logoHash: string | null,
  defaultLogoHash: string,
): boolean {
  if (!logoHash || !defaultLogoHash) return false;
  return logoHash.toLowerCase() === defaultLogoHash.toLowerCase();
}
